
import React from 'react';
import Button from 'grommet/components/Button';
import Box from 'grommet/components/Box';
import Select from 'grommet/components/Select';
import Label from 'grommet/components/Label';
import Spinning from 'grommet/components/icons/Spinning';
import {HistogramChart} from 'prophesier/dist/wrapper/index-with-deps-react.min.js';

class BubbleSample extends React.Component {
    state = {
        distData: "normal",
        spinningFlag: true,
        componentReady: false
    }
    _onClick(currentValue) {
        this.props.onSubmit(currentValue)
    }
    _onChangedist(field) {
        this.setState({distData: field.value})
    }
    componentDidMount() {
        this.setState({componentReady: true})
    }
    _onResult = (event) => {
        console.log(event)
        this.setState({spinningFlag: false})
    }
    render() {
        const {distData} = this.state
        const {dataNames} = this.props;
        console.log(distData)

        //const dataObjectParsed = this.props.dataObject ? JSON.parse(this.props.dataObject.replace(/(\r\n|\n|\r|\s)/gm,"")) : []
        let finalObjectFiltered = []
        let finalNameFiltered = []
        let spinningComponent, histograms;
        this.props.dataObject.forEach((input, index) => {
            if (this.props.dataNames[`positiontype${index + 1}`] === "Number") {
                finalObjectFiltered.push(input)
                finalNameFiltered.push(dataNames[`positionname${index+1}`])
            }
        })
        if (this.state.spinningFlag) {
            console.log("spin")
            spinningComponent = <div style={{position: "fixed", backgroundColor: "white", top: "0px", 
            bottom: "0px", right: "0px", left: "0px", opacity: "0.5", paddingTop: "30%",
            zIndex: "500", textAlign: "center"}}>
                <Label>Loading...</Label>
                <Spinning size={"huge"}/>
            </div>
        } else {
            spinningComponent = <div></div>
        }
        if (this.state.componentReady) {
            histograms = finalObjectFiltered.map((element, index)=>{
                return (
                    <div>
                        <h2>{finalNameFiltered[index]}</h2>
                        <HistogramChart index={`index${index}`} data={element} distribution={distData} result={this._onResult}/>
                    </div>
                )
            })
        } else {
            histograms = <div></div>
        }
        return (
            <div>
                {spinningComponent}
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <h2><strong>Distributions</strong></h2>
                    <Box direction='row'
                        align='center'
                        wrap={true}
                        pad='medium'
                        margin='none'>
                        <Button label='Validate Correlations'
                            type='submit'
                            primary={true}
                            onClick={this._onClick.bind(this, "dist")} 
                        />
                    </Box>
                </div>
                <hr style={{width: "100%"}} />
                <Box direction='row'
                    align='center'
                    wrap={true}
                    pad='small'
                    margin='none'>
                    <Label>
                        Fit Distribution Test
                    </Label>
                    <Box direction='row'
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'>
                        <Select placeHolder='None'
                            options={["normal", "exponential", "lognormal", "uniform", "triangular"]}
                            placeHolder={"Type"}
                            value={this.state.distData}
                            onChange={this._onChangedist.bind(this)} />
                    </Box>
                   
                </Box>
                {histograms}
                
            </div>
        );
    }
}

export default BubbleSample;


// WEBPACK FOOTER //
// ./src/samples/data/datadist.js